import React, { Component } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Dropdown } from "semantic-ui-react";
import { userValidationSchema } from "../helpers";
import { Country, UserDetail } from "../Types";
import EmailSuggestions from "./EmailSuggestions";

interface Props {
  countries: Country[];
  userDetails: UserDetail;
  isCurrentUserPresent: boolean;
  updateUserDetails: (key: string, value: string) => void;
  updateCompanyCountryDetails: (key: string, value: string) => void;
}

interface State {
  isDropdownVisible: boolean;
}

class UserForm extends Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isDropdownVisible: false,
    };
  }

  handleEmailSelection = (selectedEmail: string, setFieldValue) => {
    setFieldValue("email", selectedEmail);
    this.toggleDropdownVisibility(false);
  };

  toggleDropdownVisibility = (isVisible: boolean) => {
    this.setState({ isDropdownVisible: isVisible });
  };

  toggleDropdown = () => {
    this.state.isDropdownVisible
      ? this.toggleDropdownVisibility(false)
      : this.toggleDropdownVisibility(true);
  };

  nameParts = () => {
    const [firstName = "", ...lastNameParts] = (
      this.props.userDetails.name || ""
    ).split(" ");

    return {
      firstName,
      lastName: lastNameParts.join(" "),
    };
  };

  initialValues = () => ({
    ...this.props.userDetails,
    ...this.nameParts(),
  });

  handleNameChange = (e, key, values, setFieldValue) => {
    e.persist();

    const value = e.target.value;
    const firstName = key === "firstName" ? value : values.firstName;
    const lastName = key === "lastName" ? value : values.lastName;
    const billingName = [firstName, lastName].filter(Boolean).join(" ");

    setFieldValue(key, value);
    this.props.updateUserDetails("name", billingName);
  };

  handleChange = (e, key, setFieldValue) => {
    e.persist();

    const value = e.target.value;

    if (key == "email") {
      this.toggleDropdownVisibility(value.includes("@"));
    }
    setFieldValue(key, value);

    this.props.updateUserDetails(key, value);
  };

  handleCountryChange = (e, data, setFieldValue) => {
    setFieldValue("country", data.value);

    this.props.updateUserDetails("country", data.value);
    this.props.updateCompanyCountryDetails("country", data.value);
  };

  handleSubmit = (values) => {};

  render() {
    const { countries, userDetails, isCurrentUserPresent } = this.props;

    return (
      <div className="form-section">
        <h2 className="form-section-title">Your details</h2>
        <Formik
          initialValues={this.initialValues()}
          validationSchema={userValidationSchema(isCurrentUserPresent)}
          onSubmit={this.handleSubmit}
        >
          {({ setFieldValue, values }) => (
            <Form className="ui form">
              {!isCurrentUserPresent && (
                <>
                  <div className="input-row full">
                    <div className="form-input">
                      <label>Email</label>
                      <Field
                        id="email"
                        name="email"
                        validate={true}
                        className="required"
                        placeholder="you@example.com"
                        autoComplete="email"
                        onChange={(e) =>
                          this.handleChange(e, "email", setFieldValue)
                        }
                        onClick={this.toggleDropdown}
                      />
                      <EmailSuggestions
                        email={values.email}
                        setFieldValue={setFieldValue}
                        isDropdownVisible={this.state.isDropdownVisible}
                        onSelect={this.handleEmailSelection}
                      />
                      <ErrorMessage name="email">
                        {(msg) => <div className="error">{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                  <div className="input-row">
                    <div className="form-input">
                      <label>First name</label>
                      <Field
                        id="firstName"
                        name="firstName"
                        validate={true}
                        className="required"
                        placeholder="First name"
                        onChange={(e) =>
                          this.handleNameChange(
                            e,
                            "firstName",
                            values,
                            setFieldValue,
                          )
                        }
                      />
                      <ErrorMessage name="firstName">
                        {(msg) => <div className="error">{msg}</div>}
                      </ErrorMessage>
                    </div>
                    <div className="form-input">
                      <label>Last name</label>
                      <Field
                        id="lastName"
                        name="lastName"
                        validate={true}
                        className="required"
                        placeholder="Last name"
                        onChange={(e) =>
                          this.handleNameChange(
                            e,
                            "lastName",
                            values,
                            setFieldValue,
                          )
                        }
                      />
                      <ErrorMessage name="lastName">
                        {(msg) => <div className="error">{msg}</div>}
                      </ErrorMessage>
                    </div>
                  </div>
                </>
              )}
              <div className="input-row">
                <div className="form-input">
                  <label>Country</label>
                  <Dropdown
                    placeholder="Select Country"
                    id="select-country-dropdown"
                    fluid
                    search
                    selection
                    options={countries}
                    value={userDetails.country}
                    onChange={(e, data) =>
                      this.handleCountryChange(e, data, setFieldValue)
                    }
                  />
                  <ErrorMessage name="country">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                  <span className="detected-hint">
                    Auto-detected from your location
                  </span>
                </div>
                <div className="form-input">
                  <label>Zip/postcode</label>
                  <Field
                    id="postalCode"
                    name="postalCode"
                    validate={true}
                    className="required"
                    placeholder="12345"
                    onChange={(e) =>
                      this.handleChange(e, "postalCode", setFieldValue)
                    }
                  />
                  <ErrorMessage name="postalCode">
                    {(msg) => <div className="error">{msg}</div>}
                  </ErrorMessage>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

export default UserForm;
